import SwiperCore, { EffectFade, Navigation } from 'swiper';
import Swiper from 'swiper';

export function onlineTranslationInit() {
  $('.online-translation-button').on('click', (e) => {
    e.preventDefault();
    $('.online-translation').toggleClass('show');
  });

  SwiperCore.use([EffectFade, Navigation]);

  const slidesCount = $('.online-translation-slider-slide').length;
  $('.online-translation-slider-counters-max').text(slidesCount);
  $('.online-translation-slider-counters-min').text(1);

  const swiper = new Swiper('.online-translation-slider', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: '.online-translation-slider-next',
      prevEl: '.online-translation-slider-prev',
    },
    on: {
      slideChange: (s) => {
        $('.online-translation-slider-counters-min').text(s.activeIndex + 1);
      },
    },
  });
}
